/**
 * Filter configuration - defines all available filters and their options
 * This mirrors the blueprint configuration from intranet_product.yaml
 */

export const FILTER_GROUPS = [
    {
        handle: 'wuchsformen',
        display: 'Wuchsformen',
        options: [
            { value: 'saeulenfoermig', label: 'Säulenförmig' },
            { value: 'kugelfoermig', label: 'Kugelförmig' },
            { value: 'schirmfoermig', label: 'Schirmförmig' },
            { value: 'haengend', label: 'Hängend' },
            { value: 'bizarre', label: 'Bizarre / malerische Formen' },
            { value: 'mehrstaemmig', label: 'Mehrstämmig' },
        ],
    },
    {
        handle: 'bluete_frucht_duft',
        display: 'Blüte, Frucht & Duft',
        options: [
            { value: 'deko_frucht', label: 'Gehölze mit dekorativem Fruchtschmuck' },
            { value: 'essbare_fruechte', label: 'Essbare Früchte / Wildobst' },
            { value: 'duftgehoelze', label: 'Duftgehölze' },
        ],
    },
    {
        handle: 'laub_belaubung',
        display: 'Laub & Belaubung',
        options: [
            { value: 'besonderes_laub', label: 'Besonderes Laub (z. B. panaschiert, filigran)' },
            { value: 'herbstfaerbung', label: 'Herbstfärbung' },
            { value: 'immergruen', label: 'Immergrüne Laubgehölze' },
        ],
    },
    {
        handle: 'wurzelverhalten',
        display: 'Wurzelverhalten',
        options: [
            { value: 'auslaeuferbildend', label: 'Ausläuferbildende Gehölze' },
            { value: 'flachwurzler', label: 'Flachwurzler' },
            { value: 'hohe_vertraeglichkeit', label: 'Gehölze mit hoher Wurzel- & Kronenverträglichkeit' },
        ],
    },
    {
        handle: 'lichtansprueche',
        display: 'Lichtansprüche',
        options: [
            { value: 'sonnenliebend', label: 'Sonnenliebende Gehölze' },
            { value: 'schattentolerant', label: 'Schattentolerante Gehölze' },
        ],
    },
    {
        handle: 'bodenansprueche',
        display: 'Bodenansprüche',
        options: [
            { value: 'kalkliebend', label: 'Kalkliebende Gehölze' },
            { value: 'saure_boeden', label: 'Gehölze für saure Böden' },
            { value: 'trockene_standorte', label: 'Für trockene Standorte' },
            { value: 'feuchte_standorte', label: 'Für feuchte bis nasse Standorte' },
            { value: 'tonige_boeden', label: 'Für schwere (tonige) Böden' },
            { value: 'sandige_boeden', label: 'Für leichte (sandige) Böden' },
        ],
    },
    {
        handle: 'verwendungsschwerpunkte',
        display: 'Verwendungsschwerpunkte',
        options: [
            { value: 'heimisch', label: 'Heimische Gehölze' },
            { value: 'bienenfreundlich', label: 'Bienenfreundliche Gehölze' },
            { value: 'vogelnaehrgehoelze', label: 'Vogelnährgehölze' },
            { value: 'hang_boeschung', label: 'Gehölze zur Hang- & Böschungssicherung' },
            { value: 'bodendeckend', label: 'Bodendeckende Gehölze' },
            { value: 'kuebel_troege', label: 'Gehölze für Kübel & Tröge' },
        ],
    },
];
